import {useSelector} from 'react-redux';
import Selector from '../../../selectors/modals_action/affiliate-signup/welcome_bonus';
import PurpleButton from '../../components/purple-button';
import FormInput from '../../components/form-input';
import {useState} from 'react';

export default ({game, close}) => {
    const welcome_bonus = useSelector(Selector);

    return (
        <div className="action-modal-body-container">
            <div className="modal-body stage-body">
                <div className="stage-header">
                    <div className="left">
                        <div className="title">Crediting Your Bonus</div>
                        <div className="text">Almost there — your bonus is powering up right now.</div>
                    </div>
                    <div className="close" onClick={e => close()}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 18L18 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M18 18L6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>

                <div className="statuses">
                    {welcome_bonus.details.login ? (
                        <div className="status active">
                            <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.75 6.75L7.69737 12.75L22.75 0.75" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>

                            <span>Login has been successfully generated!</span>
                        </div>
                    ) : (
                        <div className="status">
                            <svg className="rotating" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M22 12C22 17.52 17.52 22 12 22C6.48 22 3.11 16.44 3.11 16.44M3.11 16.44H7.63M3.11 16.44L3.11 21.44M2 12C2 6.48 6.44 2 12 2C18.67 2 22 7.56 22 7.56M22 7.56V2.56M22 7.56L17.56 7.56" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>

                            <span>Generating a game login for you...</span>
                        </div>
                    )}
                    {
                        welcome_bonus.details.freeplay ? (
                            <div className="status active">
                                <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.75 6.75L7.69737 12.75L22.75 0.75" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>

                                <span>Bonus has been successfully credited!</span>
                            </div>
                        ) : (
                            <div className="status">
                                <svg className="rotating" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M22 12C22 17.52 17.52 22 12 22C6.48 22 3.11 16.44 3.11 16.44M3.11 16.44H7.63M3.11 16.44L3.11 21.44M2 12C2 6.48 6.44 2 12 2C18.67 2 22 7.56 22 7.56M22 7.56V2.56M22 7.56L17.56 7.56" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>

                                <span>Сrediting your game bonus...</span>
                            </div>
                        )
                    }
                </div>

                <div className="stage-progress">
                    <div className="game-select">
                        <div className="left">
                            <div className="image">
                                <img src={`${window.location.origin}/source/system/games/${game.slug}.png`} />
                            </div>
                            <div className="game-info">
                                <div className="label">Game Selected</div>
                                <div className="value">{game.name}</div>
                            </div>
                        </div>
                    </div>
                    <div className="map">
                        <div className="dot active"></div>
                        <div className="line active"></div>
                        <div className="dot active"></div>
                        <div className="line active"></div>
                        <div className="dot active"></div>
                        <div className="line active"></div>
                        <div className="dot active bonus selected">
                            <img src={`${window.location.origin}/source/system/modals-action/affiliate-signup/gift.png`} />
                        </div>
                    </div>
                    <div className="stages">
                        <span>Choose game</span>
                        <span>Sign Up</span>
                        <span>Notifications</span>
                        <span className="active">Claim Bonus</span>
                    </div>
                </div>
            </div>
        </div>
    )
}